import { memo, useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';

import PropTypes from 'prop-types';

import CommunityComponent from './CommunityComponent';

import { communityOptInOut, getCommunityList } from '../actions';

import { arePropsEqual } from '../../../utils';
import { formatSelect } from '../../Forms/utils';
import { getIsShowJoinCommunity } from '../utils';

import { COMMUNITY_SCOPE_OPTIONS } from '../constants';

import * as communitySelectors from '../selectors';

import { CommunitySkeleton } from '../../Shared/skeletons';
import CommunityContext from '../context';

const CommunityContainer = (props) => {
  const history = useHistory();
  const {
    getCommunityList,
    communityOptions,
    defaultCommunityOption,
    communityId,
    communityOptIn,
  } = props;

  const [search, setSearch] = useState('');
  const [community, setCommunity] = useState(defaultCommunityOption);
  const [isShowJoinCommunity, setIsShowJoinCommunity] = useState(
    getIsShowJoinCommunity(communityId),
  );
  const [communityType, setCommunityType] = useState(
    COMMUNITY_SCOPE_OPTIONS[0].value,
  );

  useEffect(() => {
    document.title = 'Community';
    getCommunityList({ enabled: true, disable_pagination: true });
  }, []);

  useEffect(() => {
    if (!community && defaultCommunityOption) {
      setCommunity(defaultCommunityOption);
    }
  }, [defaultCommunityOption]);

  const onCommunityChange = (event, newCommunity) => {
    setCommunity(newCommunity);
    history.push(`/community/list/${newCommunity?.value}`);
  };

  const onCommunityOptIn = async () => {
    const res = await communityOptIn(communityId);
    if (!res) return;
    setIsShowJoinCommunity(false);
  };

  const onSetSearch = (e) => setSearch(e.target.value);

  const checkIfCommunityMember = useCallback(() => {
    getIsShowJoinCommunity(communityId) && setIsShowJoinCommunity(true);
    return !getIsShowJoinCommunity(communityId);
  }, []);

  if (!community) return <CommunitySkeleton />;

  return (
    <CommunityContext.Provider value={checkIfCommunityMember}>
      <CommunityComponent
        community={community}
        onCommunityChange={onCommunityChange}
        communityOptions={communityOptions}
        search={search}
        setSearch={onSetSearch}
        communityType={communityType}
        setCommunityType={setCommunityType}
        isShowJoinCommunity={isShowJoinCommunity}
        setIsShowJoinCommunity={setIsShowJoinCommunity}
        onCommunityOptIn={onCommunityOptIn}
      />
    </CommunityContext.Provider>
  );
};

CommunityContainer.defaultProps = {
  defaultCommunityOption: null,
};

CommunityContainer.propTypes = {
  communityId: PropTypes.number.isRequired,
  getCommunityList: PropTypes.func.isRequired,
  communityOptIn: PropTypes.func.isRequired,
  communityOptions: PropTypes.instanceOf(Array).isRequired,
  defaultCommunityOption: PropTypes.instanceOf(Object),
};

const mapStateToProps = (state, ownProps) => {
  const communityId = communitySelectors.getCommunityId(ownProps);
  const community = communitySelectors.getCommunityById(state, communityId);
  const communityUnpagedList =
    communitySelectors.getCommunityUnpagedList(state);
  const communityOptions = formatSelect(communityUnpagedList);
  const defaultCommunityOption = communityOptions?.find(
    ({ value }) => value === communityId,
  );

  return {
    communityId,
    community,
    communityUnpagedList,
    communityOptions,
    defaultCommunityOption,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getCommunityList: (queryParams) =>
    getCommunityList(dispatch, queryParams, false, true),
  communityOptIn: (communityId) =>
    communityOptInOut(dispatch, communityId, true),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(CommunityContainer, arePropsEqual));
